(function () {
  var KEY = 'mp_wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: list } }));
  }

  function has(handle) { return read().indexOf(handle) > -1; }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.unshift(handle);
    write(list);
    return i === -1;
  }

  function paintCounts() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-wishlist-link]').forEach(function (el) { el.hidden = n === 0; });
  }

  function paintButton(btn) {
    var saved = has(btn.dataset.handle);
    var label = btn.querySelector('[data-wishlist-label]');
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    if (label) {
      if (!btn.dataset.labelIdle) btn.dataset.labelIdle = label.textContent.trim();
      label.textContent = saved ? (btn.dataset.labelSaved || 'Saved') : btn.dataset.labelIdle;
    }
  }

  var toastTimer;

  function toast(root, saved) {
    var box = root.querySelector('[data-wishlist-toast]');
    if (!box) return;
    var text = box.querySelector('[data-wishlist-toast-text]');
    var link = box.querySelector('a');
    if (text) text.textContent = saved ? (root.querySelector('[data-wishlist-toggle]').dataset.labelSaved || 'Saved') : 'Removed';
    if (link) link.hidden = !saved;
    box.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { box.hidden = true; }, 3500);
  }

  // Float the heart over the product image rather than taking a row
  function relocate() {
    var root = document.querySelector('[data-wishlist-root]');
    var media = document.querySelector('.product-information__media');
    if (root && media && root.parentElement !== media) media.appendChild(root);
  }

  function initButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (btn.dataset.wishlistReady) return;
      btn.dataset.wishlistReady = '1';
      paintButton(btn);
      btn.addEventListener('click', function () {
        var nowSaved = toggle(btn.dataset.handle);
        paintButton(btn);
        paintCounts();
        var root = btn.closest('[data-wishlist-root]');
        if (root) toast(root, nowSaved);
      });
    });
    paintCounts();
  }

  // ── Wishlist page ────────────────────────────────────────────────
  function group(str) {
    var parts = str.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function money(cents, format) {
    var f = format || 'AED {{amount}}';
    var amount = cents / 100;
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount_no_decimals':
          return group(Math.round(amount).toString());
        case 'amount_with_comma_separator':
          return group(amount.toFixed(2)).replace(/,/g, ' ').replace('.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return group(Math.round(amount).toString()).replace(/,/g, '.');
        case 'amount_with_apostrophe_separator':
          return group(amount.toFixed(2)).replace(/,/g, "'");
        default:
          return group(amount.toFixed(2));
      }
    });
  }

  function card(p, format) {
    var img = p.featured_image ? p.featured_image : (p.images && p.images[0]);
    var src = img ? (img.indexOf('//') === 0 ? 'https:' + img : img) : '';
    if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=600';
    var price = money(p.price, format);
    return (
      '<article class="mpw-card" data-mpw-card="' + p.handle + '">' +
        '<a class="mpw-card__media" href="/products/' + p.handle + '">' +
          (src ? '<img src="' + src + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="mpw-card__body">' +
          '<a class="mpw-card__title" href="/products/' + p.handle + '">' + p.title + '</a>' +
          '<span class="mpw-card__price">' + price + '</span>' +
          '<div class="mpw-card__actions">' +
            '<a class="mpw-btn mpw-btn--solid" href="/products/' + p.handle + '">View</a>' +
            '<button class="mpw-btn mpw-btn--ghost" type="button" data-mpw-remove="' + p.handle + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</article>'
    );
  }

  function renderPage(root) {
    var grid = root.querySelector('[data-mpw-grid]');
    var empty = root.querySelector('[data-mpw-empty]');
    var format = root.dataset.moneyFormat;
    var list = read();

    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    Promise.all(list.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var good = items.filter(Boolean);
      // drop anything that no longer exists
      var alive = good.map(function (p) { return p.handle; });
      if (alive.length !== list.length) write(alive);
      grid.innerHTML = good.map(function (p) { return card(p, format); }).join('');
      if (!good.length && empty) empty.hidden = false;
    });
  }

  function initPage() {
    var root = document.querySelector('[data-mpw-root]');
    if (!root) return;
    renderPage(root);
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mpw-remove]');
      if (!btn) return;
      toggle(btn.getAttribute('data-mpw-remove'));
      renderPage(root);
      paintCounts();
    });
  }

  function start() {
    relocate();
    initButtons();
    initPage();
    document.addEventListener('wishlist:change', paintCounts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // the theme swaps the buy area on variant change
  document.addEventListener('variant:update', function () { setTimeout(initButtons, 80); });
})();
